import { Injectable } from '@angular/core';

const PARTNERSTACK_XID_STORAGE_KEY = 'collectiviq.partnerstack.ps_xid';

@Injectable({
    providedIn: 'root',
})
export class PartnerstackAttributionService {
    captureClickId(xid: string | null | undefined): string | null {
        const normalizedXid = (xid ?? '').trim();

        if (!normalizedXid) {
            return null;
        }

        localStorage.setItem(PARTNERSTACK_XID_STORAGE_KEY, normalizedXid);

        return normalizedXid;
    }

    getTrackedXid(): string | null {
        const xid = localStorage.getItem(PARTNERSTACK_XID_STORAGE_KEY);

        return xid?.trim() || null;
    }

    clearTrackedXid(): void {
        localStorage.removeItem(PARTNERSTACK_XID_STORAGE_KEY);
    }
}
